import { LotChanges } from 'types';
import { getNewLots, isEmptyStateLot } from '@components/bid_request/details/utils';

/**
 * Removes the empty default lots from the lot changes during import process.
 * When importing lots, on new event creation a empty default lot is automatically created.
 * When importing lots, from a default empty lot, we remove it from the lots that already exist
 * This function identifies the empty lots (with no line items) and marks them for deletion.
 *
 * @param changes - Record mapping lot IDs to their respective change objects
 * @returns Updated changes object with the first empty lot marked for deletion (if any exists)
 */
export const removeEmptyDefaultLotsOnImport = (
  changes: Record<string, LotChanges>
): Record<string, LotChanges> => {
  const updatedChanges = { ...changes };
  const lotsWithEmpty = getNewLots(changes);

  // Find all empty lots
  const emptyLots = lotsWithEmpty.filter(isEmptyStateLot);

  // Mark all empty lots for deletion
  emptyLots.forEach(emptyLot => {
    updatedChanges[emptyLot.id] = {
      _destroy: true,
      id: emptyLot.id
    } as LotChanges;
  });

  return updatedChanges;
};
